<template>
  <div class="page">
    <div class="card">
      <base-info>
        <base-info-item label="Boutique">Boutique Name</base-info-item>
        <base-info-item label="Boutique ID">21366432</base-info-item>
        <base-info-item label="Designer ID">452312312</base-info-item>
        <base-info-item label="Color Code">FDF123</base-info-item>
        <base-info-item label="Season">19SS</base-info-item>
        <base-info-item label="Category">Men > Clothing > Shirts</base-info-item>
        <base-info-item label="Brand">Acne Studios</base-info-item>
        <base-info-item col="4" label="Product Name">T-shirt Betty Boop</base-info-item>
        <base-info-item col="4" label="Composition">Sdfwevd werwerwerwe sdfsdfsdf</base-info-item>
        <base-info-item col="4" label="Dimension">XS,S,L</base-info-item>
        <base-info-item col="4" label="Description">dsfsd3sd2 234234 dfsdfsdf sdfsdfsdfsdfsdf</base-info-item>
      </base-info>
      <attr-info class="mt10" label-width="120px">
        <attr-info-item label="Boutique Image">
          <cover-img
            :data="[
              'http://sha-oss-static.oss-cn-shanghai.aliyuncs.com/upload/7a1af475-2dfb-4564-bb15-0eaf3ef44395',
              'http://sha-oss-static.oss-cn-shanghai.aliyuncs.com/upload/037e7370-9554-45a5-b207-2da7a243215e',
              'http://sha-oss-static.oss-cn-shanghai.aliyuncs.com/upload/6a8e99bf-d1cf-41b3-b95e-95d28e7dcdc9',
              'http://sha-oss-static.oss-cn-shanghai.aliyuncs.com/upload/3d6d0af3-cb3f-4e59-add2-304d9a2ed15d',
            ]"
          ></cover-img>
        </attr-info-item>
        <attr-info-item label="Model Image">
          <cover-img
            :data="[
              'http://sha-oss-static.oss-cn-shanghai.aliyuncs.com/upload/7a1af475-2dfb-4564-bb15-0eaf3ef44395',
              'http://sha-oss-static.oss-cn-shanghai.aliyuncs.com/upload/037e7370-9554-45a5-b207-2da7a243215e',
              'http://sha-oss-static.oss-cn-shanghai.aliyuncs.com/upload/6a8e99bf-d1cf-41b3-b95e-95d28e7dcdc9',
            ]"
          ></cover-img>
        </attr-info-item>
        <attr-info-item label="Street Image">
          <cover-img
            :data="[
              'http://sha-oss-static.oss-cn-shanghai.aliyuncs.com/upload/7a1af475-2dfb-4564-bb15-0eaf3ef44395',
              'http://sha-oss-static.oss-cn-shanghai.aliyuncs.com/upload/037e7370-9554-45a5-b207-2da7a243215e',
            ]"
          ></cover-img>
        </attr-info-item>
      </attr-info>
    </div>
  </div>
</template>

<script>
import CoverImg from '@/components/CoverImg';

export default {
  name: 'Detail',
  components: {
    CoverImg,
  },
  data() {
    return {
      product: {},
    };
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
